import { createContext, useContext } from "react";

export const MapFullscreenContext = createContext(null);

export function useMapFullscreen() {
	return useContext(MapFullscreenContext);
}
